import style from './index.module.less';
import MenuIcon from '@/assets/icon/menu.svg';
import { useContext } from 'react';
import { SideBarContext } from '@/context/SideBarContext';

function RightSideBarMenu() {
  const { setMenuVisible } = useContext(SideBarContext);

  const handleClick = () => {
    setMenuVisible(true);
  };

  return (
    <div className={style.RightSideBarMenuWrapper} onClick={handleClick}>
      <div className={style.RightSideBarMenu}>
        <img src={MenuIcon} alt="" />
      </div>
    </div>
  );
}

export default RightSideBarMenu;
